import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ReportCategories } from '../../../../common/enums/reportCategories';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { translateKey } from '../../../translate';
import { Button } from '../common';

export function AddIntakeReport(props: {
    addReport?: (reportCategory: ReportCategories) => Promise<void>;
    request: IRequestGetOne;
}) {
    if (
        props.request.status !== RequestStatus.accepted ||
        !props.request.authorization ||
        !props.request.authorization.canAddIntakeDiagnosticReport ||
        !props.addReport
    ) {
        return null;
    }

    return (
        <Button
            automation="addIntakeReport"
            color="secondary"
            large
            onClick={() => props.addReport!(ReportCategories.intake)}
        >
            {translateKey('request.statusAction_addIntakeReport')}
        </Button>
    );
}
